import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './TeaserTextBox.module.scss';
type Props = {
  children: ReactNode;
  classes?: string;
  transparent?: boolean;
};

const TeaserTextBox: FC<Props> = ({
  classes,
  transparent = false,
  children,
}) => {
  return (
    <div
      className={classNames(styles.host, classes, {
        [styles.transparent]: transparent,
      })}
    >
      {children}
    </div>
  );
};

export default TeaserTextBox;
